export enum RSSArticleMaxAge {
  Unlimited = 'Unlimited',
  TenMin = '10 minutes',
  ThirtyMin = '30 minutes',
  OneHour = '1 hour',
  EightHours = '8 hours',
  OneDay = '1 day',
  TwoDays = '2 days',
  ThreeDays = '3 days',
  FiveDays = '5 days',
  SevenDays = '7 days',
  FourteenDays = '14 days',
  ThirtyDays = '30 days',
  SixtyDays = '60 days',
  NinetyDays = '90 days'
}
